import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';

/**
 * ReferralRedirect — /r/:code → drops a cookie/session marker then redirects to /register.
 * The Register page reads sessionStorage on mount and pre-fills the code.
 */
const ReferralRedirect = () => {
  const { code } = useParams();
  useEffect(() => {
    try {
      if (code) sessionStorage.setItem('indusfact_ref_code', code.toUpperCase());
    } catch { /* ignore */ }
  }, [code]);
  return <Navigate to='/register' replace />;
};

export default ReferralRedirect;
